import { Stack } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { ErrorTypography } from "components/ErrorTypography";
import { LoadingWrappedNode } from "components/LoadingWrappedNode";
import { useShipmentRoute } from "hooks";
import { toFullReadableAddress } from "utils";

import type { SelectChangeEvent } from "@mui/material/Select";

interface Props {
  shipment: CondensedShipment;
  routePointId: number | undefined;
  setRoutePointId: (newValue: number | undefined) => void;
}

function getRouteOptions(route: Route) {
  return route.route_points
    .sort((a, b) => a.point_number - b.point_number)
    .map((point: RoutePoint) => (
      <MenuItem key={point.point_number} value={point.id}>
        {`Route Point ${point.point_number} - ${toFullReadableAddress(point.point_location)}`}
      </MenuItem>
    ));
}

export function RoutePointSelect(props: Props) {
  const { shipment, routePointId, setRoutePointId } = props;

  const { route, loading, error } = useShipmentRoute(shipment.info.route);

  const handleChange = (event: SelectChangeEvent) => {
    setRoutePointId(parseInt(event.target.value, 10));
  };

  return (
    <Stack>
      <LoadingWrappedNode loading={loading || !route}>
        <FormControl fullWidth>
          <InputLabel id="route-point-input-label">Route Point</InputLabel>
          <Select
            id="route-point-select"
            value={routePointId?.toString() ?? ""}
            label="Route Point"
            onChange={handleChange}
          >
            {route?.route_points != null && getRouteOptions(route)}
          </Select>
        </FormControl>
      </LoadingWrappedNode>
      <ErrorTypography error={error} />
    </Stack>
  );
}
